// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { addEquipment, bulkDeleteFilterById, bulkUpdateFilter, clearCache, deleteApiV1BlobByPrognosisIdByBlobName, deleteApiV1FieldValuesAreasById, deleteApiV1FieldValuesById, deleteApiV1FilterById, deleteApiV1PrognosesById, deleteApiV1PrognosesDetails, deleteApiV1PrognosisSubscription, deleteFilterById, getApiV1AreaAssignmentFieldByFieldGuid, getApiV1BlobAccessToken, getApiV1BlobByPrognosisIdByBlobName, getApiV1CiWellTargetsByTargetUuid, getApiV1CiWellTargetsFieldByFieldUuid, getApiV1FieldValuesFieldByFieldUuid, getApiV1FieldValuesFieldValuesWarningByFieldUuid, getApiV1Filter, getApiV1Health, getApiV1OptionalAttributesByPrognosisId, getApiV1OsduWellboresByWellboreIdentifierWellpaths, getApiV1OsduWellpathsById, getApiV1PozoPrognosisByIdFaults, getApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepth, getApiV1Prognoses, getApiV1PrognosesById, getApiV1PrognosesByIdOutdatedEntries, getApiV1PrognosesByPrognosisIdDetails, getApiV1PrognosesByPrognosisIdDetailsLastSubmitted, getApiV1PrognosesByPrognosisIdHistory, getApiV1PrognosesByPrognosisIdLastSubmitted, getApiV1PrognosesByPrognosisIdOverlapping, getApiV1PrognosesByPrognosisIdRevisions, getApiV1PrognosesByPrognosisIdRevisionsNewest, getApiV1PrognosesDetailsCommingledHistoric, getApiV1PrognosesDetailsHistoric, getApiV1PrognosesDetailsTypes, getApiV1PrognosesEdmWellboreByEdmWellboreId, getApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioId, getApiV1PrognosesLookupValues, getApiV1PrognosesSync, getApiV1PrognosesSyncWithDetails, getApiV1ReservoirZonesLastUsed, getApiV1ReservoirZonesTopUsed, getApiV1SamUserAnalyticsPrognosis, getApiV1SmdaFieldsByFieldUuidStratColumns, getApiV1SmdaFieldsByFieldUuidWellboresAll, getApiV1SmdaWellboresByWellboreIdentifier, getApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPick, getApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAll, getApiV1SsdlWellboresByWellboreUuidPerforations, getApiV1User, getApiV1UserAccessCheckCollectionByFieldUuid, getApiV1UserApproversByFieldIdentifier, getApiV1UserApproversByFieldIdentifierAll, getApiV1UserApproversByFieldIdentifierBackup, getApiV1UserApproversByFieldIdentifierBackupAll, getApiV1UserDefaultView, getApiV1UserFutureAccesses, getApiV1UserPhotoByShortname, getApiV1UserShortnames, getApiV1UserSubmittersByFieldIdentifier, getApiV1UserSubmittersByFieldIdentifierAll, getApiV1UserUserAccess, getAreas, getConfig, getDataTypes, getDrilledWellsFeaturesByField, getEquipment, getFieldConfig, getFieldConfigs, getFieldFaultLines, getFieldOutlines, getFilterById, getFilters, getHelpLines, getMeasurementTypes, getPiLinePlot, getPressureDataByFieldFlat, getPressureHeatmap, getPressureTypes, getSamPortalProductionToken, getSamPortalToken, getStatPressHelpLines, getToken, getWellpositions, getWellsInArea, type Options, patchApiV1FilterById, patchApiV1PrognosesByIdApprove, patchApiV1PrognosesByIdDismissApprovalRetraction, patchApiV1PrognosesByIdDismissArchiving, patchApiV1PrognosesByIdExpire, patchApiV1PrognosesByIdReject, patchApiV1PrognosesByIdRequestApprovalRetraction, patchApiV1PrognosesByIdRequestArchiving, patchApiV1PrognosesByIdRetract, patchApiV1PrognosesByIdReturnToDraft, patchApiV1PrognosesByIdStep, patchApiV1PrognosesByIdStep1, patchApiV1PrognosesByIdStep2, patchApiV1PrognosesByIdStep3, patchApiV1PrognosesByIdStep5, patchApiV1PrognosesByIdSubmit, patchApiV1PrognosesDetailsByDetailIdComment, patchApiV1PrognosesDetailsByDetailIdMarkAsDone, postApiV1AreaAssignmentAssignWellbores, postApiV1BlobByPrognosisId, postApiV1FieldValues, postApiV1FieldValuesAreas, postApiV1FieldValuesUpdates, postApiV1Filter, postApiV1OptionalAttributesByPrognosisId, postApiV1PrognosedDepthsUpdates, postApiV1Prognoses, postApiV1PrognosesByIdCopy, postApiV1PrognosesByIdOutdatedEntriesDismiss, postApiV1PrognosesDetails, postApiV1PrognosisSubscription, postApiV1SmdaUpdateRelation, postApiV1TargetsUpdates, postApiV1WellborePicksUpdates, postApiV1WellboresUpdates, postApiV1WellPathsUpdates, putApiV1FieldValuesAreasById, putApiV1FieldValuesById, putApiV1OptionalAttributesByPrognosisId, putApiV1PrognosesDetails, putApiV1PrognosisSubscriptionPrognosesByPrognosisIdShare, putApiV1UserDefaultView, putApiV1UserFavoriteFieldsByFieldUuid, saveFilter, updateFieldConfig, updateFilter } from '../sdk.gen';
import type { AddEquipmentData, AddEquipmentError, AddEquipmentResponse, BulkDeleteFilterByIdData, BulkDeleteFilterByIdResponse, BulkUpdateFilterData, BulkUpdateFilterResponse, ClearCacheData, ClearCacheError, ClearCacheResponse, DeleteApiV1BlobByPrognosisIdByBlobNameData, DeleteApiV1BlobByPrognosisIdByBlobNameError, DeleteApiV1BlobByPrognosisIdByBlobNameResponse, DeleteApiV1FieldValuesAreasByIdData, DeleteApiV1FieldValuesAreasByIdError, DeleteApiV1FieldValuesAreasByIdResponse, DeleteApiV1FieldValuesByIdData, DeleteApiV1FieldValuesByIdError, DeleteApiV1FieldValuesByIdResponse, DeleteApiV1FilterByIdData, DeleteApiV1FilterByIdError, DeleteApiV1FilterByIdResponse, DeleteApiV1PrognosesByIdData, DeleteApiV1PrognosesByIdError, DeleteApiV1PrognosesByIdResponse, DeleteApiV1PrognosesDetailsData, DeleteApiV1PrognosesDetailsError, DeleteApiV1PrognosesDetailsResponse, DeleteApiV1PrognosisSubscriptionData, DeleteApiV1PrognosisSubscriptionError, DeleteApiV1PrognosisSubscriptionResponse, DeleteFilterByIdData, DeleteFilterByIdResponse, GetApiV1AreaAssignmentFieldByFieldGuidData, GetApiV1AreaAssignmentFieldByFieldGuidError, GetApiV1AreaAssignmentFieldByFieldGuidResponse, GetApiV1BlobAccessTokenData, GetApiV1BlobAccessTokenResponse, GetApiV1BlobByPrognosisIdByBlobNameData, GetApiV1BlobByPrognosisIdByBlobNameError, GetApiV1BlobByPrognosisIdByBlobNameResponse, GetApiV1CiWellTargetsByTargetUuidData, GetApiV1CiWellTargetsByTargetUuidResponse, GetApiV1CiWellTargetsFieldByFieldUuidData, GetApiV1CiWellTargetsFieldByFieldUuidResponse, GetApiV1FieldValuesFieldByFieldUuidData, GetApiV1FieldValuesFieldByFieldUuidError, GetApiV1FieldValuesFieldByFieldUuidResponse, GetApiV1FieldValuesFieldValuesWarningByFieldUuidData, GetApiV1FieldValuesFieldValuesWarningByFieldUuidError, GetApiV1FieldValuesFieldValuesWarningByFieldUuidResponse, GetApiV1FilterData, GetApiV1FilterResponse, GetApiV1HealthData, GetApiV1HealthResponse, GetApiV1OptionalAttributesByPrognosisIdData, GetApiV1OptionalAttributesByPrognosisIdError, GetApiV1OptionalAttributesByPrognosisIdResponse, GetApiV1OsduWellboresByWellboreIdentifierWellpathsData, GetApiV1OsduWellboresByWellboreIdentifierWellpathsResponse, GetApiV1OsduWellpathsByIdData, GetApiV1OsduWellpathsByIdResponse, GetApiV1PozoPrognosisByIdFaultsData, GetApiV1PozoPrognosisByIdFaultsResponse, GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthData, GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthError, GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthResponse, GetApiV1PrognosesByIdData, GetApiV1PrognosesByIdError, GetApiV1PrognosesByIdOutdatedEntriesData, GetApiV1PrognosesByIdOutdatedEntriesError, GetApiV1PrognosesByIdOutdatedEntriesResponse, GetApiV1PrognosesByIdResponse, GetApiV1PrognosesByPrognosisIdDetailsData, GetApiV1PrognosesByPrognosisIdDetailsError, GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedData, GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedError, GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedResponse, GetApiV1PrognosesByPrognosisIdDetailsResponse, GetApiV1PrognosesByPrognosisIdHistoryData, GetApiV1PrognosesByPrognosisIdHistoryError, GetApiV1PrognosesByPrognosisIdHistoryResponse, GetApiV1PrognosesByPrognosisIdLastSubmittedData, GetApiV1PrognosesByPrognosisIdLastSubmittedError, GetApiV1PrognosesByPrognosisIdLastSubmittedResponse, GetApiV1PrognosesByPrognosisIdOverlappingData, GetApiV1PrognosesByPrognosisIdOverlappingError, GetApiV1PrognosesByPrognosisIdOverlappingResponse, GetApiV1PrognosesByPrognosisIdRevisionsData, GetApiV1PrognosesByPrognosisIdRevisionsError, GetApiV1PrognosesByPrognosisIdRevisionsNewestData, GetApiV1PrognosesByPrognosisIdRevisionsNewestError, GetApiV1PrognosesByPrognosisIdRevisionsNewestResponse, GetApiV1PrognosesByPrognosisIdRevisionsResponse, GetApiV1PrognosesData, GetApiV1PrognosesDetailsCommingledHistoricData, GetApiV1PrognosesDetailsCommingledHistoricError, GetApiV1PrognosesDetailsCommingledHistoricResponse, GetApiV1PrognosesDetailsHistoricData, GetApiV1PrognosesDetailsHistoricError, GetApiV1PrognosesDetailsHistoricResponse, GetApiV1PrognosesDetailsTypesData, GetApiV1PrognosesDetailsTypesResponse, GetApiV1PrognosesEdmWellboreByEdmWellboreIdData, GetApiV1PrognosesEdmWellboreByEdmWellboreIdError, GetApiV1PrognosesEdmWellboreByEdmWellboreIdResponse, GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdData, GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdError, GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdResponse, GetApiV1PrognosesError, GetApiV1PrognosesLookupValuesData, GetApiV1PrognosesLookupValuesResponse, GetApiV1PrognosesResponse, GetApiV1PrognosesSyncData, GetApiV1PrognosesSyncError, GetApiV1PrognosesSyncResponse, GetApiV1PrognosesSyncWithDetailsData, GetApiV1PrognosesSyncWithDetailsError, GetApiV1PrognosesSyncWithDetailsResponse, GetApiV1ReservoirZonesLastUsedData, GetApiV1ReservoirZonesLastUsedError, GetApiV1ReservoirZonesLastUsedResponse, GetApiV1ReservoirZonesTopUsedData, GetApiV1ReservoirZonesTopUsedError, GetApiV1ReservoirZonesTopUsedResponse, GetApiV1SamUserAnalyticsPrognosisData, GetApiV1SamUserAnalyticsPrognosisResponse, GetApiV1SmdaFieldsByFieldUuidStratColumnsData, GetApiV1SmdaFieldsByFieldUuidStratColumnsResponse, GetApiV1SmdaFieldsByFieldUuidWellboresAllData, GetApiV1SmdaFieldsByFieldUuidWellboresAllResponse, GetApiV1SmdaWellboresByWellboreIdentifierData, GetApiV1SmdaWellboresByWellboreIdentifierResponse, GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickData, GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickError, GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickResponse, GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllData, GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllResponse, GetApiV1SsdlWellboresByWellboreUuidPerforationsData, GetApiV1SsdlWellboresByWellboreUuidPerforationsResponse, GetApiV1UserAccessCheckCollectionByFieldUuidData, GetApiV1UserAccessCheckCollectionByFieldUuidResponse, GetApiV1UserApproversByFieldIdentifierAllData, GetApiV1UserApproversByFieldIdentifierAllResponse, GetApiV1UserApproversByFieldIdentifierBackupAllData, GetApiV1UserApproversByFieldIdentifierBackupAllResponse, GetApiV1UserApproversByFieldIdentifierBackupData, GetApiV1UserApproversByFieldIdentifierBackupResponse, GetApiV1UserApproversByFieldIdentifierData, GetApiV1UserApproversByFieldIdentifierResponse, GetApiV1UserData, GetApiV1UserDefaultViewData, GetApiV1UserDefaultViewResponse, GetApiV1UserFutureAccessesData, GetApiV1UserFutureAccessesResponse, GetApiV1UserPhotoByShortnameData, GetApiV1UserPhotoByShortnameResponse, GetApiV1UserResponse, GetApiV1UserShortnamesData, GetApiV1UserShortnamesResponse, GetApiV1UserSubmittersByFieldIdentifierAllData, GetApiV1UserSubmittersByFieldIdentifierAllResponse, GetApiV1UserSubmittersByFieldIdentifierData, GetApiV1UserSubmittersByFieldIdentifierResponse, GetApiV1UserUserAccessData, GetApiV1UserUserAccessResponse, GetAreasData, GetAreasError, GetAreasResponse, GetConfigData, GetConfigResponse, GetDataTypesData, GetDataTypesResponse, GetDrilledWellsFeaturesByFieldData, GetDrilledWellsFeaturesByFieldResponse, GetEquipmentData, GetEquipmentError, GetEquipmentResponse, GetFieldConfigData, GetFieldConfigResponse, GetFieldConfigsData, GetFieldConfigsResponse, GetFieldFaultLinesData, GetFieldFaultLinesError, GetFieldFaultLinesResponse, GetFieldOutlinesData, GetFieldOutlinesError, GetFieldOutlinesResponse, GetFilterByIdData, GetFilterByIdResponse, GetFiltersData, GetFiltersResponse, GetHelpLinesData, GetHelpLinesResponse, GetMeasurementTypesData, GetMeasurementTypesResponse, GetPiLinePlotData, GetPiLinePlotResponse, GetPressureDataByFieldFlatData, GetPressureDataByFieldFlatResponse, GetPressureHeatmapData, GetPressureHeatmapError, GetPressureHeatmapResponse, GetPressureTypesData, GetPressureTypesResponse, GetSamPortalProductionTokenData, GetSamPortalProductionTokenResponse, GetSamPortalTokenData, GetSamPortalTokenResponse, GetStatPressHelpLinesData, GetStatPressHelpLinesResponse, GetTokenData, GetTokenResponse, GetWellpositionsData, GetWellpositionsError, GetWellpositionsResponse, GetWellsInAreaData, GetWellsInAreaResponse, PatchApiV1FilterByIdData, PatchApiV1FilterByIdError, PatchApiV1FilterByIdResponse, PatchApiV1PrognosesByIdApproveData, PatchApiV1PrognosesByIdApproveError, PatchApiV1PrognosesByIdApproveResponse, PatchApiV1PrognosesByIdDismissApprovalRetractionData, PatchApiV1PrognosesByIdDismissApprovalRetractionError, PatchApiV1PrognosesByIdDismissApprovalRetractionResponse, PatchApiV1PrognosesByIdDismissArchivingData, PatchApiV1PrognosesByIdDismissArchivingError, PatchApiV1PrognosesByIdDismissArchivingResponse, PatchApiV1PrognosesByIdExpireData, PatchApiV1PrognosesByIdExpireError, PatchApiV1PrognosesByIdExpireResponse, PatchApiV1PrognosesByIdRejectData, PatchApiV1PrognosesByIdRejectError, PatchApiV1PrognosesByIdRejectResponse, PatchApiV1PrognosesByIdRequestApprovalRetractionData, PatchApiV1PrognosesByIdRequestApprovalRetractionError, PatchApiV1PrognosesByIdRequestApprovalRetractionResponse, PatchApiV1PrognosesByIdRequestArchivingData, PatchApiV1PrognosesByIdRequestArchivingError, PatchApiV1PrognosesByIdRequestArchivingResponse, PatchApiV1PrognosesByIdRetractData, PatchApiV1PrognosesByIdRetractError, PatchApiV1PrognosesByIdRetractResponse, PatchApiV1PrognosesByIdReturnToDraftData, PatchApiV1PrognosesByIdReturnToDraftError, PatchApiV1PrognosesByIdReturnToDraftResponse, PatchApiV1PrognosesByIdStep1Data, PatchApiV1PrognosesByIdStep1Error, PatchApiV1PrognosesByIdStep1Response, PatchApiV1PrognosesByIdStep2Data, PatchApiV1PrognosesByIdStep2Error, PatchApiV1PrognosesByIdStep2Response, PatchApiV1PrognosesByIdStep3Data, PatchApiV1PrognosesByIdStep3Error, PatchApiV1PrognosesByIdStep3Response, PatchApiV1PrognosesByIdStep5Data, PatchApiV1PrognosesByIdStep5Error, PatchApiV1PrognosesByIdStep5Response, PatchApiV1PrognosesByIdStepData, PatchApiV1PrognosesByIdStepError, PatchApiV1PrognosesByIdStepResponse, PatchApiV1PrognosesByIdSubmitData, PatchApiV1PrognosesByIdSubmitError, PatchApiV1PrognosesByIdSubmitResponse, PatchApiV1PrognosesDetailsByDetailIdCommentData, PatchApiV1PrognosesDetailsByDetailIdCommentError, PatchApiV1PrognosesDetailsByDetailIdCommentResponse, PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneData, PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneError, PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneResponse, PostApiV1AreaAssignmentAssignWellboresData, PostApiV1AreaAssignmentAssignWellboresError, PostApiV1AreaAssignmentAssignWellboresResponse, PostApiV1BlobByPrognosisIdData, PostApiV1BlobByPrognosisIdError, PostApiV1BlobByPrognosisIdResponse, PostApiV1FieldValuesAreasData, PostApiV1FieldValuesAreasError, PostApiV1FieldValuesAreasResponse, PostApiV1FieldValuesData, PostApiV1FieldValuesError, PostApiV1FieldValuesResponse, PostApiV1FieldValuesUpdatesData, PostApiV1FieldValuesUpdatesError, PostApiV1FilterData, PostApiV1FilterError, PostApiV1FilterResponse, PostApiV1OptionalAttributesByPrognosisIdData, PostApiV1OptionalAttributesByPrognosisIdError, PostApiV1OptionalAttributesByPrognosisIdResponse, PostApiV1PrognosedDepthsUpdatesData, PostApiV1PrognosedDepthsUpdatesError, PostApiV1PrognosesByIdCopyData, PostApiV1PrognosesByIdCopyError, PostApiV1PrognosesByIdCopyResponse, PostApiV1PrognosesByIdOutdatedEntriesDismissData, PostApiV1PrognosesByIdOutdatedEntriesDismissError, PostApiV1PrognosesData, PostApiV1PrognosesDetailsData, PostApiV1PrognosesDetailsError, PostApiV1PrognosesDetailsResponse, PostApiV1PrognosesError, PostApiV1PrognosesResponse, PostApiV1PrognosisSubscriptionData, PostApiV1PrognosisSubscriptionError, PostApiV1PrognosisSubscriptionResponse, PostApiV1SmdaUpdateRelationData, PostApiV1SmdaUpdateRelationError, PostApiV1TargetsUpdatesData, PostApiV1TargetsUpdatesError, PostApiV1WellborePicksUpdatesData, PostApiV1WellborePicksUpdatesError, PostApiV1WellboresUpdatesData, PostApiV1WellboresUpdatesError, PostApiV1WellPathsUpdatesData, PostApiV1WellPathsUpdatesError, PutApiV1FieldValuesAreasByIdData, PutApiV1FieldValuesAreasByIdError, PutApiV1FieldValuesAreasByIdResponse, PutApiV1FieldValuesByIdData, PutApiV1FieldValuesByIdError, PutApiV1FieldValuesByIdResponse, PutApiV1OptionalAttributesByPrognosisIdData, PutApiV1OptionalAttributesByPrognosisIdError, PutApiV1OptionalAttributesByPrognosisIdResponse, PutApiV1PrognosesDetailsData, PutApiV1PrognosesDetailsError, PutApiV1PrognosesDetailsResponse, PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareData, PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareError, PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareResponse, PutApiV1UserDefaultViewData, PutApiV1UserDefaultViewError, PutApiV1UserDefaultViewResponse, PutApiV1UserFavoriteFieldsByFieldUuidData, PutApiV1UserFavoriteFieldsByFieldUuidError, PutApiV1UserFavoriteFieldsByFieldUuidResponse, SaveFilterData, SaveFilterResponse, UpdateFieldConfigData, UpdateFieldConfigResponse, UpdateFilterData, UpdateFilterResponse } from '../types.gen';

/**
 * Assign wellbores to an area
 */
export const postApiV1AreaAssignmentAssignWellboresMutation = (options?: Partial<Options<PostApiV1AreaAssignmentAssignWellboresData>>): UseMutationOptions<PostApiV1AreaAssignmentAssignWellboresResponse, PostApiV1AreaAssignmentAssignWellboresError, Options<PostApiV1AreaAssignmentAssignWellboresData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1AreaAssignmentAssignWellboresResponse, PostApiV1AreaAssignmentAssignWellboresError, Options<PostApiV1AreaAssignmentAssignWellboresData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1AreaAssignmentAssignWellbores({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getApiV1AreaAssignmentFieldByFieldGuidQueryKey = (options: Options<GetApiV1AreaAssignmentFieldByFieldGuidData>) => createQueryKey('getApiV1AreaAssignmentFieldByFieldGuid', options);

/**
 * Get all wellbore area assignments for a field
 */
export const getApiV1AreaAssignmentFieldByFieldGuidOptions = (options: Options<GetApiV1AreaAssignmentFieldByFieldGuidData>) => queryOptions<GetApiV1AreaAssignmentFieldByFieldGuidResponse, GetApiV1AreaAssignmentFieldByFieldGuidError, GetApiV1AreaAssignmentFieldByFieldGuidResponse, ReturnType<typeof getApiV1AreaAssignmentFieldByFieldGuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1AreaAssignmentFieldByFieldGuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1AreaAssignmentFieldByFieldGuidQueryKey(options)
});

export const getApiV1BlobAccessTokenQueryKey = (options?: Options<GetApiV1BlobAccessTokenData>) => createQueryKey('getApiV1BlobAccessToken', options);

/**
 * Get access token for blob storage
 */
export const getApiV1BlobAccessTokenOptions = (options?: Options<GetApiV1BlobAccessTokenData>) => queryOptions<GetApiV1BlobAccessTokenResponse, DefaultError, GetApiV1BlobAccessTokenResponse, ReturnType<typeof getApiV1BlobAccessTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1BlobAccessToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1BlobAccessTokenQueryKey(options)
});

/**
 * Delete a blob
 */
export const deleteApiV1BlobByPrognosisIdByBlobNameMutation = (options?: Partial<Options<DeleteApiV1BlobByPrognosisIdByBlobNameData>>): UseMutationOptions<DeleteApiV1BlobByPrognosisIdByBlobNameResponse, DeleteApiV1BlobByPrognosisIdByBlobNameError, Options<DeleteApiV1BlobByPrognosisIdByBlobNameData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1BlobByPrognosisIdByBlobNameResponse, DeleteApiV1BlobByPrognosisIdByBlobNameError, Options<DeleteApiV1BlobByPrognosisIdByBlobNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1BlobByPrognosisIdByBlobName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1BlobByPrognosisIdByBlobNameQueryKey = (options: Options<GetApiV1BlobByPrognosisIdByBlobNameData>) => createQueryKey('getApiV1BlobByPrognosisIdByBlobName', options);

/**
 * Get blob by blob name
 */
export const getApiV1BlobByPrognosisIdByBlobNameOptions = (options: Options<GetApiV1BlobByPrognosisIdByBlobNameData>) => queryOptions<GetApiV1BlobByPrognosisIdByBlobNameResponse, GetApiV1BlobByPrognosisIdByBlobNameError, GetApiV1BlobByPrognosisIdByBlobNameResponse, ReturnType<typeof getApiV1BlobByPrognosisIdByBlobNameQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1BlobByPrognosisIdByBlobName({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1BlobByPrognosisIdByBlobNameQueryKey(options)
});

/**
 * Upload a new blob
 */
export const postApiV1BlobByPrognosisIdMutation = (options?: Partial<Options<PostApiV1BlobByPrognosisIdData>>): UseMutationOptions<PostApiV1BlobByPrognosisIdResponse, PostApiV1BlobByPrognosisIdError, Options<PostApiV1BlobByPrognosisIdData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1BlobByPrognosisIdResponse, PostApiV1BlobByPrognosisIdError, Options<PostApiV1BlobByPrognosisIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1BlobByPrognosisId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clear all entries from the Redis cache
 */
export const clearCacheMutation = (options?: Partial<Options<ClearCacheData>>): UseMutationOptions<ClearCacheResponse, ClearCacheError, Options<ClearCacheData>> => {
    const mutationOptions: UseMutationOptions<ClearCacheResponse, ClearCacheError, Options<ClearCacheData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await clearCache({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1CiWellTargetsByTargetUuidQueryKey = (options: Options<GetApiV1CiWellTargetsByTargetUuidData>) => createQueryKey('getApiV1CiWellTargetsByTargetUuid', options);

/**
 * Get well target
 */
export const getApiV1CiWellTargetsByTargetUuidOptions = (options: Options<GetApiV1CiWellTargetsByTargetUuidData>) => queryOptions<GetApiV1CiWellTargetsByTargetUuidResponse, DefaultError, GetApiV1CiWellTargetsByTargetUuidResponse, ReturnType<typeof getApiV1CiWellTargetsByTargetUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1CiWellTargetsByTargetUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1CiWellTargetsByTargetUuidQueryKey(options)
});

export const getApiV1CiWellTargetsFieldByFieldUuidQueryKey = (options: Options<GetApiV1CiWellTargetsFieldByFieldUuidData>) => createQueryKey('getApiV1CiWellTargetsFieldByFieldUuid', options);

/**
 * Get well targets for a field
 */
export const getApiV1CiWellTargetsFieldByFieldUuidOptions = (options: Options<GetApiV1CiWellTargetsFieldByFieldUuidData>) => queryOptions<GetApiV1CiWellTargetsFieldByFieldUuidResponse, DefaultError, GetApiV1CiWellTargetsFieldByFieldUuidResponse, ReturnType<typeof getApiV1CiWellTargetsFieldByFieldUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1CiWellTargetsFieldByFieldUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1CiWellTargetsFieldByFieldUuidQueryKey(options)
});

export const getDataTypesQueryKey = (options?: Options<GetDataTypesData>) => createQueryKey('getDataTypes', options);

export const getDataTypesOptions = (options?: Options<GetDataTypesData>) => queryOptions<GetDataTypesResponse, DefaultError, GetDataTypesResponse, ReturnType<typeof getDataTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDataTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDataTypesQueryKey(options)
});

export const getPressureTypesQueryKey = (options?: Options<GetPressureTypesData>) => createQueryKey('getPressureTypes', options);

export const getPressureTypesOptions = (options?: Options<GetPressureTypesData>) => queryOptions<GetPressureTypesResponse, DefaultError, GetPressureTypesResponse, ReturnType<typeof getPressureTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPressureTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPressureTypesQueryKey(options)
});

export const getMeasurementTypesQueryKey = (options?: Options<GetMeasurementTypesData>) => createQueryKey('getMeasurementTypes', options);

export const getMeasurementTypesOptions = (options?: Options<GetMeasurementTypesData>) => queryOptions<GetMeasurementTypesResponse, DefaultError, GetMeasurementTypesResponse, ReturnType<typeof getMeasurementTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMeasurementTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeasurementTypesQueryKey(options)
});

export const getConfigQueryKey = (options?: Options<GetConfigData>) => createQueryKey('getConfig', options);

export const getConfigOptions = (options?: Options<GetConfigData>) => queryOptions<GetConfigResponse, DefaultError, GetConfigResponse, ReturnType<typeof getConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getConfigQueryKey(options)
});

export const getFieldConfigsQueryKey = (options?: Options<GetFieldConfigsData>) => createQueryKey('getFieldConfigs', options);

/**
 * Retrieves all field configs
 */
export const getFieldConfigsOptions = (options?: Options<GetFieldConfigsData>) => queryOptions<GetFieldConfigsResponse, DefaultError, GetFieldConfigsResponse, ReturnType<typeof getFieldConfigsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFieldConfigs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFieldConfigsQueryKey(options)
});

export const getFieldConfigQueryKey = (options: Options<GetFieldConfigData>) => createQueryKey('getFieldConfig', options);

/**
 * Retrieves field config for given fieldId
 */
export const getFieldConfigOptions = (options: Options<GetFieldConfigData>) => queryOptions<GetFieldConfigResponse, DefaultError, GetFieldConfigResponse, ReturnType<typeof getFieldConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFieldConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFieldConfigQueryKey(options)
});

/**
 * Update field config for given fieldId
 */
export const updateFieldConfigMutation = (options?: Partial<Options<UpdateFieldConfigData>>): UseMutationOptions<UpdateFieldConfigResponse, DefaultError, Options<UpdateFieldConfigData>> => {
    const mutationOptions: UseMutationOptions<UpdateFieldConfigResponse, DefaultError, Options<UpdateFieldConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateFieldConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEquipmentQueryKey = (options: Options<GetEquipmentData>) => createQueryKey('getEquipment', options);

/**
 * Get equipment for a wellbore from ssdl
 */
export const getEquipmentOptions = (options: Options<GetEquipmentData>) => queryOptions<GetEquipmentResponse, GetEquipmentError, GetEquipmentResponse, ReturnType<typeof getEquipmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEquipment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEquipmentQueryKey(options)
});

/**
 * Post equipment for a wellbore to database
 */
export const addEquipmentMutation = (options?: Partial<Options<AddEquipmentData>>): UseMutationOptions<AddEquipmentResponse, AddEquipmentError, Options<AddEquipmentData>> => {
    const mutationOptions: UseMutationOptions<AddEquipmentResponse, AddEquipmentError, Options<AddEquipmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addEquipment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFieldOutlinesQueryKey = (options: Options<GetFieldOutlinesData>) => createQueryKey('getFieldOutlines', options);

/**
 * Get outlines for a field
 */
export const getFieldOutlinesOptions = (options: Options<GetFieldOutlinesData>) => queryOptions<GetFieldOutlinesResponse, GetFieldOutlinesError, GetFieldOutlinesResponse, ReturnType<typeof getFieldOutlinesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFieldOutlines({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFieldOutlinesQueryKey(options)
});

export const getFieldFaultLinesQueryKey = (options: Options<GetFieldFaultLinesData>) => createQueryKey('getFieldFaultLines', options);

/**
 * Get fault lines for a field
 */
export const getFieldFaultLinesOptions = (options: Options<GetFieldFaultLinesData>) => queryOptions<GetFieldFaultLinesResponse, GetFieldFaultLinesError, GetFieldFaultLinesResponse, ReturnType<typeof getFieldFaultLinesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFieldFaultLines({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFieldFaultLinesQueryKey(options)
});

export const getAreasQueryKey = (options: Options<GetAreasData>) => createQueryKey('getAreas', options);

/**
 * GetArea outlines for a field
 */
export const getAreasOptions = (options: Options<GetAreasData>) => queryOptions<GetAreasResponse, GetAreasError, GetAreasResponse, ReturnType<typeof getAreasQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAreas({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAreasQueryKey(options)
});

export const getWellsInAreaQueryKey = (options: Options<GetWellsInAreaData>) => createQueryKey('getWellsInArea', options);

/**
 * Get Wells in area
 */
export const getWellsInAreaOptions = (options: Options<GetWellsInAreaData>) => queryOptions<GetWellsInAreaResponse, DefaultError, GetWellsInAreaResponse, ReturnType<typeof getWellsInAreaQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWellsInArea({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWellsInAreaQueryKey(options)
});

export const getWellpositionsQueryKey = (options: Options<GetWellpositionsData>) => createQueryKey('getWellpositions', options);

/**
 * wellpositions for a field
 */
export const getWellpositionsOptions = (options: Options<GetWellpositionsData>) => queryOptions<GetWellpositionsResponse, GetWellpositionsError, GetWellpositionsResponse, ReturnType<typeof getWellpositionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWellpositions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWellpositionsQueryKey(options)
});

export const getApiV1FieldValuesFieldByFieldUuidQueryKey = (options: Options<GetApiV1FieldValuesFieldByFieldUuidData>) => createQueryKey('getApiV1FieldValuesFieldByFieldUuid', options);

/**
 * Get field values for a field
 */
export const getApiV1FieldValuesFieldByFieldUuidOptions = (options: Options<GetApiV1FieldValuesFieldByFieldUuidData>) => queryOptions<GetApiV1FieldValuesFieldByFieldUuidResponse, GetApiV1FieldValuesFieldByFieldUuidError, GetApiV1FieldValuesFieldByFieldUuidResponse, ReturnType<typeof getApiV1FieldValuesFieldByFieldUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1FieldValuesFieldByFieldUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1FieldValuesFieldByFieldUuidQueryKey(options)
});

/**
 * Create new field values
 */
export const postApiV1FieldValuesMutation = (options?: Partial<Options<PostApiV1FieldValuesData>>): UseMutationOptions<PostApiV1FieldValuesResponse, PostApiV1FieldValuesError, Options<PostApiV1FieldValuesData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1FieldValuesResponse, PostApiV1FieldValuesError, Options<PostApiV1FieldValuesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1FieldValues({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete field values
 */
export const deleteApiV1FieldValuesByIdMutation = (options?: Partial<Options<DeleteApiV1FieldValuesByIdData>>): UseMutationOptions<DeleteApiV1FieldValuesByIdResponse, DeleteApiV1FieldValuesByIdError, Options<DeleteApiV1FieldValuesByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1FieldValuesByIdResponse, DeleteApiV1FieldValuesByIdError, Options<DeleteApiV1FieldValuesByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1FieldValuesById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update field values
 */
export const putApiV1FieldValuesByIdMutation = (options?: Partial<Options<PutApiV1FieldValuesByIdData>>): UseMutationOptions<PutApiV1FieldValuesByIdResponse, PutApiV1FieldValuesByIdError, Options<PutApiV1FieldValuesByIdData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1FieldValuesByIdResponse, PutApiV1FieldValuesByIdError, Options<PutApiV1FieldValuesByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1FieldValuesById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create new area
 */
export const postApiV1FieldValuesAreasMutation = (options?: Partial<Options<PostApiV1FieldValuesAreasData>>): UseMutationOptions<PostApiV1FieldValuesAreasResponse, PostApiV1FieldValuesAreasError, Options<PostApiV1FieldValuesAreasData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1FieldValuesAreasResponse, PostApiV1FieldValuesAreasError, Options<PostApiV1FieldValuesAreasData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1FieldValuesAreas({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete area
 */
export const deleteApiV1FieldValuesAreasByIdMutation = (options?: Partial<Options<DeleteApiV1FieldValuesAreasByIdData>>): UseMutationOptions<DeleteApiV1FieldValuesAreasByIdResponse, DeleteApiV1FieldValuesAreasByIdError, Options<DeleteApiV1FieldValuesAreasByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1FieldValuesAreasByIdResponse, DeleteApiV1FieldValuesAreasByIdError, Options<DeleteApiV1FieldValuesAreasByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1FieldValuesAreasById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update area
 */
export const putApiV1FieldValuesAreasByIdMutation = (options?: Partial<Options<PutApiV1FieldValuesAreasByIdData>>): UseMutationOptions<PutApiV1FieldValuesAreasByIdResponse, PutApiV1FieldValuesAreasByIdError, Options<PutApiV1FieldValuesAreasByIdData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1FieldValuesAreasByIdResponse, PutApiV1FieldValuesAreasByIdError, Options<PutApiV1FieldValuesAreasByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1FieldValuesAreasById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1FieldValuesFieldValuesWarningByFieldUuidQueryKey = (options: Options<GetApiV1FieldValuesFieldValuesWarningByFieldUuidData>) => createQueryKey('getApiV1FieldValuesFieldValuesWarningByFieldUuid', options);

/**
 * Get missing field values for a field
 */
export const getApiV1FieldValuesFieldValuesWarningByFieldUuidOptions = (options: Options<GetApiV1FieldValuesFieldValuesWarningByFieldUuidData>) => queryOptions<GetApiV1FieldValuesFieldValuesWarningByFieldUuidResponse, GetApiV1FieldValuesFieldValuesWarningByFieldUuidError, GetApiV1FieldValuesFieldValuesWarningByFieldUuidResponse, ReturnType<typeof getApiV1FieldValuesFieldValuesWarningByFieldUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1FieldValuesFieldValuesWarningByFieldUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1FieldValuesFieldValuesWarningByFieldUuidQueryKey(options)
});

export const getApiV1FilterQueryKey = (options?: Options<GetApiV1FilterData>) => createQueryKey('getApiV1Filter', options);

/**
 * Get user filters
 */
export const getApiV1FilterOptions = (options?: Options<GetApiV1FilterData>) => queryOptions<GetApiV1FilterResponse, DefaultError, GetApiV1FilterResponse, ReturnType<typeof getApiV1FilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1Filter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1FilterQueryKey(options)
});

/**
 * Create a new filter
 */
export const postApiV1FilterMutation = (options?: Partial<Options<PostApiV1FilterData>>): UseMutationOptions<PostApiV1FilterResponse, PostApiV1FilterError, Options<PostApiV1FilterData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1FilterResponse, PostApiV1FilterError, Options<PostApiV1FilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1Filter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a filter
 */
export const deleteApiV1FilterByIdMutation = (options?: Partial<Options<DeleteApiV1FilterByIdData>>): UseMutationOptions<DeleteApiV1FilterByIdResponse, DeleteApiV1FilterByIdError, Options<DeleteApiV1FilterByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1FilterByIdResponse, DeleteApiV1FilterByIdError, Options<DeleteApiV1FilterByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1FilterById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update filter title
 */
export const patchApiV1FilterByIdMutation = (options?: Partial<Options<PatchApiV1FilterByIdData>>): UseMutationOptions<PatchApiV1FilterByIdResponse, PatchApiV1FilterByIdError, Options<PatchApiV1FilterByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1FilterByIdResponse, PatchApiV1FilterByIdError, Options<PatchApiV1FilterByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1FilterById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1HealthQueryKey = (options?: Options<GetApiV1HealthData>) => createQueryKey('getApiV1Health', options);

export const getApiV1HealthOptions = (options?: Options<GetApiV1HealthData>) => queryOptions<GetApiV1HealthResponse, DefaultError, GetApiV1HealthResponse, ReturnType<typeof getApiV1HealthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1Health({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1HealthQueryKey(options)
});

export const getHelpLinesMutation = (options?: Partial<Options<GetHelpLinesData>>): UseMutationOptions<GetHelpLinesResponse, DefaultError, Options<GetHelpLinesData>> => {
    const mutationOptions: UseMutationOptions<GetHelpLinesResponse, DefaultError, Options<GetHelpLinesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getHelpLines({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStatPressHelpLinesMutation = (options?: Partial<Options<GetStatPressHelpLinesData>>): UseMutationOptions<GetStatPressHelpLinesResponse, DefaultError, Options<GetStatPressHelpLinesData>> => {
    const mutationOptions: UseMutationOptions<GetStatPressHelpLinesResponse, DefaultError, Options<GetStatPressHelpLinesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getStatPressHelpLines({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1PrognosesByPrognosisIdLastSubmittedQueryKey = (options: Options<GetApiV1PrognosesByPrognosisIdLastSubmittedData>) => createQueryKey('getApiV1PrognosesByPrognosisIdLastSubmitted', options);

/**
 * Get last submitted prognosis
 */
export const getApiV1PrognosesByPrognosisIdLastSubmittedOptions = (options: Options<GetApiV1PrognosesByPrognosisIdLastSubmittedData>) => queryOptions<GetApiV1PrognosesByPrognosisIdLastSubmittedResponse, GetApiV1PrognosesByPrognosisIdLastSubmittedError, GetApiV1PrognosesByPrognosisIdLastSubmittedResponse, ReturnType<typeof getApiV1PrognosesByPrognosisIdLastSubmittedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PrognosesByPrognosisIdLastSubmitted({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesByPrognosisIdLastSubmittedQueryKey(options)
});

export const getApiV1PrognosesByPrognosisIdDetailsLastSubmittedQueryKey = (options: Options<GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedData>) => createQueryKey('getApiV1PrognosesByPrognosisIdDetailsLastSubmitted', options);

/**
 * Get last submitted prognosis details
 */
export const getApiV1PrognosesByPrognosisIdDetailsLastSubmittedOptions = (options: Options<GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedData>) => queryOptions<GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedResponse, GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedError, GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedResponse, ReturnType<typeof getApiV1PrognosesByPrognosisIdDetailsLastSubmittedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PrognosesByPrognosisIdDetailsLastSubmitted({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesByPrognosisIdDetailsLastSubmittedQueryKey(options)
});

export const getApiV1PrognosesLookupValuesQueryKey = (options?: Options<GetApiV1PrognosesLookupValuesData>) => createQueryKey('getApiV1PrognosesLookupValues', options);

/**
 * Get lookup values
 */
export const getApiV1PrognosesLookupValuesOptions = (options?: Options<GetApiV1PrognosesLookupValuesData>) => queryOptions<GetApiV1PrognosesLookupValuesResponse, DefaultError, GetApiV1PrognosesLookupValuesResponse, ReturnType<typeof getApiV1PrognosesLookupValuesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PrognosesLookupValues({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesLookupValuesQueryKey(options)
});

export const getFiltersQueryKey = (options?: Options<GetFiltersData>) => createQueryKey('getFilters', options);

export const getFiltersOptions = (options?: Options<GetFiltersData>) => queryOptions<GetFiltersResponse, DefaultError, GetFiltersResponse, ReturnType<typeof getFiltersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFilters({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFiltersQueryKey(options)
});

/**
 * Saves a measuredDataFilter
 */
export const saveFilterMutation = (options?: Partial<Options<SaveFilterData>>): UseMutationOptions<SaveFilterResponse, DefaultError, Options<SaveFilterData>> => {
    const mutationOptions: UseMutationOptions<SaveFilterResponse, DefaultError, Options<SaveFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Updates a measuredDataFilter
 */
export const updateFilterMutation = (options?: Partial<Options<UpdateFilterData>>): UseMutationOptions<UpdateFilterResponse, DefaultError, Options<UpdateFilterData>> => {
    const mutationOptions: UseMutationOptions<UpdateFilterResponse, DefaultError, Options<UpdateFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk updates filters
 */
export const bulkUpdateFilterMutation = (options?: Partial<Options<BulkUpdateFilterData>>): UseMutationOptions<BulkUpdateFilterResponse, DefaultError, Options<BulkUpdateFilterData>> => {
    const mutationOptions: UseMutationOptions<BulkUpdateFilterResponse, DefaultError, Options<BulkUpdateFilterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkUpdateFilter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deletes a filter by id
 */
export const deleteFilterByIdMutation = (options?: Partial<Options<DeleteFilterByIdData>>): UseMutationOptions<DeleteFilterByIdResponse, DefaultError, Options<DeleteFilterByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteFilterByIdResponse, DefaultError, Options<DeleteFilterByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteFilterById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFilterByIdQueryKey = (options: Options<GetFilterByIdData>) => createQueryKey('getFilterById', options);

/**
 * Gets a filter by id
 */
export const getFilterByIdOptions = (options: Options<GetFilterByIdData>) => queryOptions<GetFilterByIdResponse, DefaultError, GetFilterByIdResponse, ReturnType<typeof getFilterByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFilterById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFilterByIdQueryKey(options)
});

/**
 * Bulk Deletes  filters by id
 */
export const bulkDeleteFilterByIdMutation = (options?: Partial<Options<BulkDeleteFilterByIdData>>): UseMutationOptions<BulkDeleteFilterByIdResponse, DefaultError, Options<BulkDeleteFilterByIdData>> => {
    const mutationOptions: UseMutationOptions<BulkDeleteFilterByIdResponse, DefaultError, Options<BulkDeleteFilterByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkDeleteFilterById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1OptionalAttributesByPrognosisIdQueryKey = (options: Options<GetApiV1OptionalAttributesByPrognosisIdData>) => createQueryKey('getApiV1OptionalAttributesByPrognosisId', options);

/**
 * Get optional attributes for a prognosis
 */
export const getApiV1OptionalAttributesByPrognosisIdOptions = (options: Options<GetApiV1OptionalAttributesByPrognosisIdData>) => queryOptions<GetApiV1OptionalAttributesByPrognosisIdResponse, GetApiV1OptionalAttributesByPrognosisIdError, GetApiV1OptionalAttributesByPrognosisIdResponse, ReturnType<typeof getApiV1OptionalAttributesByPrognosisIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1OptionalAttributesByPrognosisId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1OptionalAttributesByPrognosisIdQueryKey(options)
});

/**
 * Create optional attributes for a prognosis
 */
export const postApiV1OptionalAttributesByPrognosisIdMutation = (options?: Partial<Options<PostApiV1OptionalAttributesByPrognosisIdData>>): UseMutationOptions<PostApiV1OptionalAttributesByPrognosisIdResponse, PostApiV1OptionalAttributesByPrognosisIdError, Options<PostApiV1OptionalAttributesByPrognosisIdData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1OptionalAttributesByPrognosisIdResponse, PostApiV1OptionalAttributesByPrognosisIdError, Options<PostApiV1OptionalAttributesByPrognosisIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1OptionalAttributesByPrognosisId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update optional attributes for a prognosis
 */
export const putApiV1OptionalAttributesByPrognosisIdMutation = (options?: Partial<Options<PutApiV1OptionalAttributesByPrognosisIdData>>): UseMutationOptions<PutApiV1OptionalAttributesByPrognosisIdResponse, PutApiV1OptionalAttributesByPrognosisIdError, Options<PutApiV1OptionalAttributesByPrognosisIdData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1OptionalAttributesByPrognosisIdResponse, PutApiV1OptionalAttributesByPrognosisIdError, Options<PutApiV1OptionalAttributesByPrognosisIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1OptionalAttributesByPrognosisId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1OsduWellboresByWellboreIdentifierWellpathsQueryKey = (options: Options<GetApiV1OsduWellboresByWellboreIdentifierWellpathsData>) => createQueryKey('getApiV1OsduWellboresByWellboreIdentifierWellpaths', options);

/**
 * Get well paths for new wells
 */
export const getApiV1OsduWellboresByWellboreIdentifierWellpathsOptions = (options: Options<GetApiV1OsduWellboresByWellboreIdentifierWellpathsData>) => queryOptions<GetApiV1OsduWellboresByWellboreIdentifierWellpathsResponse, DefaultError, GetApiV1OsduWellboresByWellboreIdentifierWellpathsResponse, ReturnType<typeof getApiV1OsduWellboresByWellboreIdentifierWellpathsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1OsduWellboresByWellboreIdentifierWellpaths({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1OsduWellboresByWellboreIdentifierWellpathsQueryKey(options)
});

export const getApiV1OsduWellpathsByIdQueryKey = (options: Options<GetApiV1OsduWellpathsByIdData>) => createQueryKey('getApiV1OsduWellpathsById', options);

/**
 * Get well path by OSDU well path Id
 */
export const getApiV1OsduWellpathsByIdOptions = (options: Options<GetApiV1OsduWellpathsByIdData>) => queryOptions<GetApiV1OsduWellpathsByIdResponse, DefaultError, GetApiV1OsduWellpathsByIdResponse, ReturnType<typeof getApiV1OsduWellpathsByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1OsduWellpathsById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1OsduWellpathsByIdQueryKey(options)
});

export const getApiV1PrognosesByPrognosisIdOverlappingQueryKey = (options: Options<GetApiV1PrognosesByPrognosisIdOverlappingData>) => createQueryKey('getApiV1PrognosesByPrognosisIdOverlapping', options);

/**
 * Get overlapping prognoses by prognosis ID
 */
export const getApiV1PrognosesByPrognosisIdOverlappingOptions = (options: Options<GetApiV1PrognosesByPrognosisIdOverlappingData>) => queryOptions<GetApiV1PrognosesByPrognosisIdOverlappingResponse, GetApiV1PrognosesByPrognosisIdOverlappingError, GetApiV1PrognosesByPrognosisIdOverlappingResponse, ReturnType<typeof getApiV1PrognosesByPrognosisIdOverlappingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PrognosesByPrognosisIdOverlapping({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesByPrognosisIdOverlappingQueryKey(options)
});

export const getApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthQueryKey = (options: Options<GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthData>) => createQueryKey('getApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepth', options);

/**
 * Get prognosed depth from Pozo
 *
 * Allowed DetailType values are ZoneTop or ZoneBase. Default value is ZoneTop. DetailType is not applicable for Total Depth and will be ignored.
 */
export const getApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthOptions = (options: Options<GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthData>) => queryOptions<GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthResponse, GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthError, GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthResponse, ReturnType<typeof getApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthQueryKey(options)
});

export const getApiV1PozoPrognosisByIdFaultsQueryKey = (options: Options<GetApiV1PozoPrognosisByIdFaultsData>) => createQueryKey('getApiV1PozoPrognosisByIdFaults', options);

/**
 * Get faults from Pozo
 */
export const getApiV1PozoPrognosisByIdFaultsOptions = (options: Options<GetApiV1PozoPrognosisByIdFaultsData>) => queryOptions<GetApiV1PozoPrognosisByIdFaultsResponse, DefaultError, GetApiV1PozoPrognosisByIdFaultsResponse, ReturnType<typeof getApiV1PozoPrognosisByIdFaultsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PozoPrognosisByIdFaults({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PozoPrognosisByIdFaultsQueryKey(options)
});

export const getPressureDataByFieldFlatQueryKey = (options: Options<GetPressureDataByFieldFlatData>) => createQueryKey('getPressureDataByFieldFlat', options);

/**
 * Get pressuredata for a field flat
 */
export const getPressureDataByFieldFlatOptions = (options: Options<GetPressureDataByFieldFlatData>) => queryOptions<GetPressureDataByFieldFlatResponse, DefaultError, GetPressureDataByFieldFlatResponse, ReturnType<typeof getPressureDataByFieldFlatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPressureDataByFieldFlat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPressureDataByFieldFlatQueryKey(options)
});

/**
 * Get heatmap data for a field
 */
export const getPressureHeatmapMutation = (options?: Partial<Options<GetPressureHeatmapData>>): UseMutationOptions<GetPressureHeatmapResponse, GetPressureHeatmapError, Options<GetPressureHeatmapData>> => {
    const mutationOptions: UseMutationOptions<GetPressureHeatmapResponse, GetPressureHeatmapError, Options<GetPressureHeatmapData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getPressureHeatmap({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPiLinePlotQueryKey = (options: Options<GetPiLinePlotData>) => createQueryKey('getPiLinePlot', options);

/**
 * Gets interpolated PI
 */
export const getPiLinePlotOptions = (options: Options<GetPiLinePlotData>) => queryOptions<GetPiLinePlotResponse, DefaultError, GetPiLinePlotResponse, ReturnType<typeof getPiLinePlotQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPiLinePlot({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPiLinePlotQueryKey(options)
});

export const getApiV1PrognosesQueryKey = (options?: Options<GetApiV1PrognosesData>) => createQueryKey('getApiV1Prognoses', options);

/**
 * Get prognoses
 */
export const getApiV1PrognosesOptions = (options?: Options<GetApiV1PrognosesData>) => queryOptions<GetApiV1PrognosesResponse, GetApiV1PrognosesError, GetApiV1PrognosesResponse, ReturnType<typeof getApiV1PrognosesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1Prognoses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesQueryKey(options)
});

/**
 * Create a new draft prognosis
 */
export const postApiV1PrognosesMutation = (options?: Partial<Options<PostApiV1PrognosesData>>): UseMutationOptions<PostApiV1PrognosesResponse, PostApiV1PrognosesError, Options<PostApiV1PrognosesData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PrognosesResponse, PostApiV1PrognosesError, Options<PostApiV1PrognosesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1Prognoses({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete prognosis
 */
export const deleteApiV1PrognosesByIdMutation = (options?: Partial<Options<DeleteApiV1PrognosesByIdData>>): UseMutationOptions<DeleteApiV1PrognosesByIdResponse, DeleteApiV1PrognosesByIdError, Options<DeleteApiV1PrognosesByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1PrognosesByIdResponse, DeleteApiV1PrognosesByIdError, Options<DeleteApiV1PrognosesByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1PrognosesById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1PrognosesByIdQueryKey = (options: Options<GetApiV1PrognosesByIdData>) => createQueryKey('getApiV1PrognosesById', options);

/**
 * Get prognosis by id
 */
export const getApiV1PrognosesByIdOptions = (options: Options<GetApiV1PrognosesByIdData>) => queryOptions<GetApiV1PrognosesByIdResponse, GetApiV1PrognosesByIdError, GetApiV1PrognosesByIdResponse, ReturnType<typeof getApiV1PrognosesByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PrognosesById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesByIdQueryKey(options)
});

export const getApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdQueryKey = (options: Options<GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdData>) => createQueryKey('getApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioId', options);

/**
 * Get active prognosis by EDM wellboreId and scenarioId
 */
export const getApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdOptions = (options: Options<GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdData>) => queryOptions<GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdResponse, GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdError, GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdResponse, ReturnType<typeof getApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdQueryKey(options)
});

export const getApiV1PrognosesEdmWellboreByEdmWellboreIdQueryKey = (options: Options<GetApiV1PrognosesEdmWellboreByEdmWellboreIdData>) => createQueryKey('getApiV1PrognosesEdmWellboreByEdmWellboreId', options);

/**
 * Get active prognoses by EDM wellboreId
 */
export const getApiV1PrognosesEdmWellboreByEdmWellboreIdOptions = (options: Options<GetApiV1PrognosesEdmWellboreByEdmWellboreIdData>) => queryOptions<GetApiV1PrognosesEdmWellboreByEdmWellboreIdResponse, GetApiV1PrognosesEdmWellboreByEdmWellboreIdError, GetApiV1PrognosesEdmWellboreByEdmWellboreIdResponse, ReturnType<typeof getApiV1PrognosesEdmWellboreByEdmWellboreIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PrognosesEdmWellboreByEdmWellboreId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesEdmWellboreByEdmWellboreIdQueryKey(options)
});

/**
 * Create a copy of prognosis
 */
export const postApiV1PrognosesByIdCopyMutation = (options?: Partial<Options<PostApiV1PrognosesByIdCopyData>>): UseMutationOptions<PostApiV1PrognosesByIdCopyResponse, PostApiV1PrognosesByIdCopyError, Options<PostApiV1PrognosesByIdCopyData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PrognosesByIdCopyResponse, PostApiV1PrognosesByIdCopyError, Options<PostApiV1PrognosesByIdCopyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1PrognosesByIdCopy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Patch draft prognosis step 1
 */
export const patchApiV1PrognosesByIdStep1Mutation = (options?: Partial<Options<PatchApiV1PrognosesByIdStep1Data>>): UseMutationOptions<PatchApiV1PrognosesByIdStep1Response, PatchApiV1PrognosesByIdStep1Error, Options<PatchApiV1PrognosesByIdStep1Data>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1PrognosesByIdStep1Response, PatchApiV1PrognosesByIdStep1Error, Options<PatchApiV1PrognosesByIdStep1Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1PrognosesByIdStep1({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Patch draft prognosis step 2
 */
export const patchApiV1PrognosesByIdStep2Mutation = (options?: Partial<Options<PatchApiV1PrognosesByIdStep2Data>>): UseMutationOptions<PatchApiV1PrognosesByIdStep2Response, PatchApiV1PrognosesByIdStep2Error, Options<PatchApiV1PrognosesByIdStep2Data>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1PrognosesByIdStep2Response, PatchApiV1PrognosesByIdStep2Error, Options<PatchApiV1PrognosesByIdStep2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1PrognosesByIdStep2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Patch draft prognosis step 3
 */
export const patchApiV1PrognosesByIdStep3Mutation = (options?: Partial<Options<PatchApiV1PrognosesByIdStep3Data>>): UseMutationOptions<PatchApiV1PrognosesByIdStep3Response, PatchApiV1PrognosesByIdStep3Error, Options<PatchApiV1PrognosesByIdStep3Data>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1PrognosesByIdStep3Response, PatchApiV1PrognosesByIdStep3Error, Options<PatchApiV1PrognosesByIdStep3Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1PrognosesByIdStep3({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Patch draft prognosis step 5
 */
export const patchApiV1PrognosesByIdStep5Mutation = (options?: Partial<Options<PatchApiV1PrognosesByIdStep5Data>>): UseMutationOptions<PatchApiV1PrognosesByIdStep5Response, PatchApiV1PrognosesByIdStep5Error, Options<PatchApiV1PrognosesByIdStep5Data>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1PrognosesByIdStep5Response, PatchApiV1PrognosesByIdStep5Error, Options<PatchApiV1PrognosesByIdStep5Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1PrognosesByIdStep5({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Patch prognosis step
 */
export const patchApiV1PrognosesByIdStepMutation = (options?: Partial<Options<PatchApiV1PrognosesByIdStepData>>): UseMutationOptions<PatchApiV1PrognosesByIdStepResponse, PatchApiV1PrognosesByIdStepError, Options<PatchApiV1PrognosesByIdStepData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1PrognosesByIdStepResponse, PatchApiV1PrognosesByIdStepError, Options<PatchApiV1PrognosesByIdStepData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1PrognosesByIdStep({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit prognosis
 */
export const patchApiV1PrognosesByIdSubmitMutation = (options?: Partial<Options<PatchApiV1PrognosesByIdSubmitData>>): UseMutationOptions<PatchApiV1PrognosesByIdSubmitResponse, PatchApiV1PrognosesByIdSubmitError, Options<PatchApiV1PrognosesByIdSubmitData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1PrognosesByIdSubmitResponse, PatchApiV1PrognosesByIdSubmitError, Options<PatchApiV1PrognosesByIdSubmitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1PrognosesByIdSubmit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Return prognosis to draft
 */
export const patchApiV1PrognosesByIdReturnToDraftMutation = (options?: Partial<Options<PatchApiV1PrognosesByIdReturnToDraftData>>): UseMutationOptions<PatchApiV1PrognosesByIdReturnToDraftResponse, PatchApiV1PrognosesByIdReturnToDraftError, Options<PatchApiV1PrognosesByIdReturnToDraftData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1PrognosesByIdReturnToDraftResponse, PatchApiV1PrognosesByIdReturnToDraftError, Options<PatchApiV1PrognosesByIdReturnToDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1PrognosesByIdReturnToDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject prognosis
 */
export const patchApiV1PrognosesByIdRejectMutation = (options?: Partial<Options<PatchApiV1PrognosesByIdRejectData>>): UseMutationOptions<PatchApiV1PrognosesByIdRejectResponse, PatchApiV1PrognosesByIdRejectError, Options<PatchApiV1PrognosesByIdRejectData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1PrognosesByIdRejectResponse, PatchApiV1PrognosesByIdRejectError, Options<PatchApiV1PrognosesByIdRejectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1PrognosesByIdReject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retract prognosis
 */
export const patchApiV1PrognosesByIdRetractMutation = (options?: Partial<Options<PatchApiV1PrognosesByIdRetractData>>): UseMutationOptions<PatchApiV1PrognosesByIdRetractResponse, PatchApiV1PrognosesByIdRetractError, Options<PatchApiV1PrognosesByIdRetractData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1PrognosesByIdRetractResponse, PatchApiV1PrognosesByIdRetractError, Options<PatchApiV1PrognosesByIdRetractData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1PrognosesByIdRetract({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve prognosis
 */
export const patchApiV1PrognosesByIdApproveMutation = (options?: Partial<Options<PatchApiV1PrognosesByIdApproveData>>): UseMutationOptions<PatchApiV1PrognosesByIdApproveResponse, PatchApiV1PrognosesByIdApproveError, Options<PatchApiV1PrognosesByIdApproveData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1PrognosesByIdApproveResponse, PatchApiV1PrognosesByIdApproveError, Options<PatchApiV1PrognosesByIdApproveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1PrognosesByIdApprove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Expire prognosis
 */
export const patchApiV1PrognosesByIdExpireMutation = (options?: Partial<Options<PatchApiV1PrognosesByIdExpireData>>): UseMutationOptions<PatchApiV1PrognosesByIdExpireResponse, PatchApiV1PrognosesByIdExpireError, Options<PatchApiV1PrognosesByIdExpireData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1PrognosesByIdExpireResponse, PatchApiV1PrognosesByIdExpireError, Options<PatchApiV1PrognosesByIdExpireData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1PrognosesByIdExpire({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request approval retraction
 */
export const patchApiV1PrognosesByIdRequestApprovalRetractionMutation = (options?: Partial<Options<PatchApiV1PrognosesByIdRequestApprovalRetractionData>>): UseMutationOptions<PatchApiV1PrognosesByIdRequestApprovalRetractionResponse, PatchApiV1PrognosesByIdRequestApprovalRetractionError, Options<PatchApiV1PrognosesByIdRequestApprovalRetractionData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1PrognosesByIdRequestApprovalRetractionResponse, PatchApiV1PrognosesByIdRequestApprovalRetractionError, Options<PatchApiV1PrognosesByIdRequestApprovalRetractionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1PrognosesByIdRequestApprovalRetraction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Dismiss approval retraction request
 */
export const patchApiV1PrognosesByIdDismissApprovalRetractionMutation = (options?: Partial<Options<PatchApiV1PrognosesByIdDismissApprovalRetractionData>>): UseMutationOptions<PatchApiV1PrognosesByIdDismissApprovalRetractionResponse, PatchApiV1PrognosesByIdDismissApprovalRetractionError, Options<PatchApiV1PrognosesByIdDismissApprovalRetractionData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1PrognosesByIdDismissApprovalRetractionResponse, PatchApiV1PrognosesByIdDismissApprovalRetractionError, Options<PatchApiV1PrognosesByIdDismissApprovalRetractionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1PrognosesByIdDismissApprovalRetraction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request archiving
 */
export const patchApiV1PrognosesByIdRequestArchivingMutation = (options?: Partial<Options<PatchApiV1PrognosesByIdRequestArchivingData>>): UseMutationOptions<PatchApiV1PrognosesByIdRequestArchivingResponse, PatchApiV1PrognosesByIdRequestArchivingError, Options<PatchApiV1PrognosesByIdRequestArchivingData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1PrognosesByIdRequestArchivingResponse, PatchApiV1PrognosesByIdRequestArchivingError, Options<PatchApiV1PrognosesByIdRequestArchivingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1PrognosesByIdRequestArchiving({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Dismiss archiving request
 */
export const patchApiV1PrognosesByIdDismissArchivingMutation = (options?: Partial<Options<PatchApiV1PrognosesByIdDismissArchivingData>>): UseMutationOptions<PatchApiV1PrognosesByIdDismissArchivingResponse, PatchApiV1PrognosesByIdDismissArchivingError, Options<PatchApiV1PrognosesByIdDismissArchivingData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1PrognosesByIdDismissArchivingResponse, PatchApiV1PrognosesByIdDismissArchivingError, Options<PatchApiV1PrognosesByIdDismissArchivingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1PrognosesByIdDismissArchiving({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1PrognosesByPrognosisIdDetailsQueryKey = (options: Options<GetApiV1PrognosesByPrognosisIdDetailsData>) => createQueryKey('getApiV1PrognosesByPrognosisIdDetails', options);

/**
 * Get details by prognosis ID
 */
export const getApiV1PrognosesByPrognosisIdDetailsOptions = (options: Options<GetApiV1PrognosesByPrognosisIdDetailsData>) => queryOptions<GetApiV1PrognosesByPrognosisIdDetailsResponse, GetApiV1PrognosesByPrognosisIdDetailsError, GetApiV1PrognosesByPrognosisIdDetailsResponse, ReturnType<typeof getApiV1PrognosesByPrognosisIdDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PrognosesByPrognosisIdDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesByPrognosisIdDetailsQueryKey(options)
});

/**
 * Delete details
 */
export const deleteApiV1PrognosesDetailsMutation = (options?: Partial<Options<DeleteApiV1PrognosesDetailsData>>): UseMutationOptions<DeleteApiV1PrognosesDetailsResponse, DeleteApiV1PrognosesDetailsError, Options<DeleteApiV1PrognosesDetailsData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1PrognosesDetailsResponse, DeleteApiV1PrognosesDetailsError, Options<DeleteApiV1PrognosesDetailsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1PrognosesDetails({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create new details
 */
export const postApiV1PrognosesDetailsMutation = (options?: Partial<Options<PostApiV1PrognosesDetailsData>>): UseMutationOptions<PostApiV1PrognosesDetailsResponse, PostApiV1PrognosesDetailsError, Options<PostApiV1PrognosesDetailsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PrognosesDetailsResponse, PostApiV1PrognosesDetailsError, Options<PostApiV1PrognosesDetailsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1PrognosesDetails({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update details
 */
export const putApiV1PrognosesDetailsMutation = (options?: Partial<Options<PutApiV1PrognosesDetailsData>>): UseMutationOptions<PutApiV1PrognosesDetailsResponse, PutApiV1PrognosesDetailsError, Options<PutApiV1PrognosesDetailsData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1PrognosesDetailsResponse, PutApiV1PrognosesDetailsError, Options<PutApiV1PrognosesDetailsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1PrognosesDetails({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Patch detail comment
 */
export const patchApiV1PrognosesDetailsByDetailIdCommentMutation = (options?: Partial<Options<PatchApiV1PrognosesDetailsByDetailIdCommentData>>): UseMutationOptions<PatchApiV1PrognosesDetailsByDetailIdCommentResponse, PatchApiV1PrognosesDetailsByDetailIdCommentError, Options<PatchApiV1PrognosesDetailsByDetailIdCommentData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1PrognosesDetailsByDetailIdCommentResponse, PatchApiV1PrognosesDetailsByDetailIdCommentError, Options<PatchApiV1PrognosesDetailsByDetailIdCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1PrognosesDetailsByDetailIdComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Patch detail mark as done
 */
export const patchApiV1PrognosesDetailsByDetailIdMarkAsDoneMutation = (options?: Partial<Options<PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneData>>): UseMutationOptions<PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneResponse, PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneError, Options<PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneResponse, PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneError, Options<PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1PrognosesDetailsByDetailIdMarkAsDone({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1PrognosesDetailsHistoricQueryKey = (options: Options<GetApiV1PrognosesDetailsHistoricData>) => createQueryKey('getApiV1PrognosesDetailsHistoric', options);

/**
 * Get historic prognosis details
 */
export const getApiV1PrognosesDetailsHistoricOptions = (options: Options<GetApiV1PrognosesDetailsHistoricData>) => queryOptions<GetApiV1PrognosesDetailsHistoricResponse, GetApiV1PrognosesDetailsHistoricError, GetApiV1PrognosesDetailsHistoricResponse, ReturnType<typeof getApiV1PrognosesDetailsHistoricQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PrognosesDetailsHistoric({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesDetailsHistoricQueryKey(options)
});

export const getApiV1PrognosesDetailsCommingledHistoricQueryKey = (options: Options<GetApiV1PrognosesDetailsCommingledHistoricData>) => createQueryKey('getApiV1PrognosesDetailsCommingledHistoric', options);

/**
 * Get historic prognosis details for a commingled prognosis
 */
export const getApiV1PrognosesDetailsCommingledHistoricOptions = (options: Options<GetApiV1PrognosesDetailsCommingledHistoricData>) => queryOptions<GetApiV1PrognosesDetailsCommingledHistoricResponse, GetApiV1PrognosesDetailsCommingledHistoricError, GetApiV1PrognosesDetailsCommingledHistoricResponse, ReturnType<typeof getApiV1PrognosesDetailsCommingledHistoricQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PrognosesDetailsCommingledHistoric({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesDetailsCommingledHistoricQueryKey(options)
});

export const getApiV1PrognosesDetailsTypesQueryKey = (options?: Options<GetApiV1PrognosesDetailsTypesData>) => createQueryKey('getApiV1PrognosesDetailsTypes', options);

/**
 * Get prognosis detail types
 */
export const getApiV1PrognosesDetailsTypesOptions = (options?: Options<GetApiV1PrognosesDetailsTypesData>) => queryOptions<GetApiV1PrognosesDetailsTypesResponse, DefaultError, GetApiV1PrognosesDetailsTypesResponse, ReturnType<typeof getApiV1PrognosesDetailsTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PrognosesDetailsTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesDetailsTypesQueryKey(options)
});

export const getApiV1PrognosesByPrognosisIdHistoryQueryKey = (options: Options<GetApiV1PrognosesByPrognosisIdHistoryData>) => createQueryKey('getApiV1PrognosesByPrognosisIdHistory', options);

/**
 * Get prognosis history
 */
export const getApiV1PrognosesByPrognosisIdHistoryOptions = (options: Options<GetApiV1PrognosesByPrognosisIdHistoryData>) => queryOptions<GetApiV1PrognosesByPrognosisIdHistoryResponse, GetApiV1PrognosesByPrognosisIdHistoryError, GetApiV1PrognosesByPrognosisIdHistoryResponse, ReturnType<typeof getApiV1PrognosesByPrognosisIdHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PrognosesByPrognosisIdHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesByPrognosisIdHistoryQueryKey(options)
});

export const getApiV1PrognosesByPrognosisIdRevisionsQueryKey = (options: Options<GetApiV1PrognosesByPrognosisIdRevisionsData>) => createQueryKey('getApiV1PrognosesByPrognosisIdRevisions', options);

/**
 * Get prognosis revision history
 */
export const getApiV1PrognosesByPrognosisIdRevisionsOptions = (options: Options<GetApiV1PrognosesByPrognosisIdRevisionsData>) => queryOptions<GetApiV1PrognosesByPrognosisIdRevisionsResponse, GetApiV1PrognosesByPrognosisIdRevisionsError, GetApiV1PrognosesByPrognosisIdRevisionsResponse, ReturnType<typeof getApiV1PrognosesByPrognosisIdRevisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PrognosesByPrognosisIdRevisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesByPrognosisIdRevisionsQueryKey(options)
});

export const getApiV1PrognosesByPrognosisIdRevisionsNewestQueryKey = (options: Options<GetApiV1PrognosesByPrognosisIdRevisionsNewestData>) => createQueryKey('getApiV1PrognosesByPrognosisIdRevisionsNewest', options);

/**
 * Get the newest approved/historical prognosis
 */
export const getApiV1PrognosesByPrognosisIdRevisionsNewestOptions = (options: Options<GetApiV1PrognosesByPrognosisIdRevisionsNewestData>) => queryOptions<GetApiV1PrognosesByPrognosisIdRevisionsNewestResponse, GetApiV1PrognosesByPrognosisIdRevisionsNewestError, GetApiV1PrognosesByPrognosisIdRevisionsNewestResponse, ReturnType<typeof getApiV1PrognosesByPrognosisIdRevisionsNewestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PrognosesByPrognosisIdRevisionsNewest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesByPrognosisIdRevisionsNewestQueryKey(options)
});

export const getApiV1PrognosesByIdOutdatedEntriesQueryKey = (options: Options<GetApiV1PrognosesByIdOutdatedEntriesData>) => createQueryKey('getApiV1PrognosesByIdOutdatedEntries', options);

/**
 * Get outdated entries for a prognosis
 */
export const getApiV1PrognosesByIdOutdatedEntriesOptions = (options: Options<GetApiV1PrognosesByIdOutdatedEntriesData>) => queryOptions<GetApiV1PrognosesByIdOutdatedEntriesResponse, GetApiV1PrognosesByIdOutdatedEntriesError, GetApiV1PrognosesByIdOutdatedEntriesResponse, ReturnType<typeof getApiV1PrognosesByIdOutdatedEntriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PrognosesByIdOutdatedEntries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesByIdOutdatedEntriesQueryKey(options)
});

/**
 * Dismiss all warnings for a prognosis
 */
export const postApiV1PrognosesByIdOutdatedEntriesDismissMutation = (options?: Partial<Options<PostApiV1PrognosesByIdOutdatedEntriesDismissData>>): UseMutationOptions<unknown, PostApiV1PrognosesByIdOutdatedEntriesDismissError, Options<PostApiV1PrognosesByIdOutdatedEntriesDismissData>> => {
    const mutationOptions: UseMutationOptions<unknown, PostApiV1PrognosesByIdOutdatedEntriesDismissError, Options<PostApiV1PrognosesByIdOutdatedEntriesDismissData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1PrognosesByIdOutdatedEntriesDismiss({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check for target updates
 */
export const postApiV1TargetsUpdatesMutation = (options?: Partial<Options<PostApiV1TargetsUpdatesData>>): UseMutationOptions<unknown, PostApiV1TargetsUpdatesError, Options<PostApiV1TargetsUpdatesData>> => {
    const mutationOptions: UseMutationOptions<unknown, PostApiV1TargetsUpdatesError, Options<PostApiV1TargetsUpdatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1TargetsUpdates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check for wellbore updates
 */
export const postApiV1WellboresUpdatesMutation = (options?: Partial<Options<PostApiV1WellboresUpdatesData>>): UseMutationOptions<unknown, PostApiV1WellboresUpdatesError, Options<PostApiV1WellboresUpdatesData>> => {
    const mutationOptions: UseMutationOptions<unknown, PostApiV1WellboresUpdatesError, Options<PostApiV1WellboresUpdatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WellboresUpdates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check for well path updates
 */
export const postApiV1WellPathsUpdatesMutation = (options?: Partial<Options<PostApiV1WellPathsUpdatesData>>): UseMutationOptions<unknown, PostApiV1WellPathsUpdatesError, Options<PostApiV1WellPathsUpdatesData>> => {
    const mutationOptions: UseMutationOptions<unknown, PostApiV1WellPathsUpdatesError, Options<PostApiV1WellPathsUpdatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WellPathsUpdates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check for field values updates
 */
export const postApiV1FieldValuesUpdatesMutation = (options?: Partial<Options<PostApiV1FieldValuesUpdatesData>>): UseMutationOptions<unknown, PostApiV1FieldValuesUpdatesError, Options<PostApiV1FieldValuesUpdatesData>> => {
    const mutationOptions: UseMutationOptions<unknown, PostApiV1FieldValuesUpdatesError, Options<PostApiV1FieldValuesUpdatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1FieldValuesUpdates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check for wellbore pick updates
 */
export const postApiV1WellborePicksUpdatesMutation = (options?: Partial<Options<PostApiV1WellborePicksUpdatesData>>): UseMutationOptions<unknown, PostApiV1WellborePicksUpdatesError, Options<PostApiV1WellborePicksUpdatesData>> => {
    const mutationOptions: UseMutationOptions<unknown, PostApiV1WellborePicksUpdatesError, Options<PostApiV1WellborePicksUpdatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WellborePicksUpdates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check for prognosed depth updates
 */
export const postApiV1PrognosedDepthsUpdatesMutation = (options?: Partial<Options<PostApiV1PrognosedDepthsUpdatesData>>): UseMutationOptions<unknown, PostApiV1PrognosedDepthsUpdatesError, Options<PostApiV1PrognosedDepthsUpdatesData>> => {
    const mutationOptions: UseMutationOptions<unknown, PostApiV1PrognosedDepthsUpdatesError, Options<PostApiV1PrognosedDepthsUpdatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1PrognosedDepthsUpdates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unsubscribe from prognosis email notifications
 */
export const deleteApiV1PrognosisSubscriptionMutation = (options?: Partial<Options<DeleteApiV1PrognosisSubscriptionData>>): UseMutationOptions<DeleteApiV1PrognosisSubscriptionResponse, DeleteApiV1PrognosisSubscriptionError, Options<DeleteApiV1PrognosisSubscriptionData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1PrognosisSubscriptionResponse, DeleteApiV1PrognosisSubscriptionError, Options<DeleteApiV1PrognosisSubscriptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1PrognosisSubscription({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Subscribe to prognosis email notifications
 */
export const postApiV1PrognosisSubscriptionMutation = (options?: Partial<Options<PostApiV1PrognosisSubscriptionData>>): UseMutationOptions<PostApiV1PrognosisSubscriptionResponse, PostApiV1PrognosisSubscriptionError, Options<PostApiV1PrognosisSubscriptionData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PrognosisSubscriptionResponse, PostApiV1PrognosisSubscriptionError, Options<PostApiV1PrognosisSubscriptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1PrognosisSubscription({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Share prognosis with users
 */
export const putApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareMutation = (options?: Partial<Options<PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareData>>): UseMutationOptions<PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareResponse, PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareError, Options<PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareResponse, PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareError, Options<PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1PrognosisSubscriptionPrognosesByPrognosisIdShare({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1PrognosesSyncQueryKey = (options?: Options<GetApiV1PrognosesSyncData>) => createQueryKey('getApiV1PrognosesSync', options);

/**
 * Sync prognoses to PressureDB. Returns IDs of failed syncs
 */
export const getApiV1PrognosesSyncOptions = (options?: Options<GetApiV1PrognosesSyncData>) => queryOptions<GetApiV1PrognosesSyncResponse, GetApiV1PrognosesSyncError, GetApiV1PrognosesSyncResponse, ReturnType<typeof getApiV1PrognosesSyncQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PrognosesSync({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesSyncQueryKey(options)
});

export const getApiV1PrognosesSyncWithDetailsQueryKey = (options?: Options<GetApiV1PrognosesSyncWithDetailsData>) => createQueryKey('getApiV1PrognosesSyncWithDetails', options);

/**
 * Sync prognoses and details to PressureDB. Returns IDs of failed syncs
 */
export const getApiV1PrognosesSyncWithDetailsOptions = (options?: Options<GetApiV1PrognosesSyncWithDetailsData>) => queryOptions<GetApiV1PrognosesSyncWithDetailsResponse, GetApiV1PrognosesSyncWithDetailsError, GetApiV1PrognosesSyncWithDetailsResponse, ReturnType<typeof getApiV1PrognosesSyncWithDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PrognosesSyncWithDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PrognosesSyncWithDetailsQueryKey(options)
});

export const getApiV1ReservoirZonesTopUsedQueryKey = (options: Options<GetApiV1ReservoirZonesTopUsedData>) => createQueryKey('getApiV1ReservoirZonesTopUsed', options);

/**
 * Get top used reservoir zones
 */
export const getApiV1ReservoirZonesTopUsedOptions = (options: Options<GetApiV1ReservoirZonesTopUsedData>) => queryOptions<GetApiV1ReservoirZonesTopUsedResponse, GetApiV1ReservoirZonesTopUsedError, GetApiV1ReservoirZonesTopUsedResponse, ReturnType<typeof getApiV1ReservoirZonesTopUsedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ReservoirZonesTopUsed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ReservoirZonesTopUsedQueryKey(options)
});

export const getApiV1ReservoirZonesLastUsedQueryKey = (options: Options<GetApiV1ReservoirZonesLastUsedData>) => createQueryKey('getApiV1ReservoirZonesLastUsed', options);

/**
 * Get last used reservoir zones
 */
export const getApiV1ReservoirZonesLastUsedOptions = (options: Options<GetApiV1ReservoirZonesLastUsedData>) => queryOptions<GetApiV1ReservoirZonesLastUsedResponse, GetApiV1ReservoirZonesLastUsedError, GetApiV1ReservoirZonesLastUsedResponse, ReturnType<typeof getApiV1ReservoirZonesLastUsedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ReservoirZonesLastUsed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ReservoirZonesLastUsedQueryKey(options)
});

export const getApiV1SamUserAnalyticsPrognosisQueryKey = (options?: Options<GetApiV1SamUserAnalyticsPrognosisData>) => createQueryKey('getApiV1SamUserAnalyticsPrognosis', options);

/**
 * Get prognosis user analytics for SAM
 */
export const getApiV1SamUserAnalyticsPrognosisOptions = (options?: Options<GetApiV1SamUserAnalyticsPrognosisData>) => queryOptions<GetApiV1SamUserAnalyticsPrognosisResponse, DefaultError, GetApiV1SamUserAnalyticsPrognosisResponse, ReturnType<typeof getApiV1SamUserAnalyticsPrognosisQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1SamUserAnalyticsPrognosis({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1SamUserAnalyticsPrognosisQueryKey(options)
});

export const getApiV1SmdaWellboresByWellboreIdentifierQueryKey = (options: Options<GetApiV1SmdaWellboresByWellboreIdentifierData>) => createQueryKey('getApiV1SmdaWellboresByWellboreIdentifier', options);

/**
 * Get wellbore by identifier
 */
export const getApiV1SmdaWellboresByWellboreIdentifierOptions = (options: Options<GetApiV1SmdaWellboresByWellboreIdentifierData>) => queryOptions<GetApiV1SmdaWellboresByWellboreIdentifierResponse, DefaultError, GetApiV1SmdaWellboresByWellboreIdentifierResponse, ReturnType<typeof getApiV1SmdaWellboresByWellboreIdentifierQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1SmdaWellboresByWellboreIdentifier({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1SmdaWellboresByWellboreIdentifierQueryKey(options)
});

export const getApiV1SmdaFieldsByFieldUuidWellboresAllQueryKey = (options: Options<GetApiV1SmdaFieldsByFieldUuidWellboresAllData>) => createQueryKey('getApiV1SmdaFieldsByFieldUuidWellboresAll', options);

/**
 * Get wellbores by field Uuid
 */
export const getApiV1SmdaFieldsByFieldUuidWellboresAllOptions = (options: Options<GetApiV1SmdaFieldsByFieldUuidWellboresAllData>) => queryOptions<GetApiV1SmdaFieldsByFieldUuidWellboresAllResponse, DefaultError, GetApiV1SmdaFieldsByFieldUuidWellboresAllResponse, ReturnType<typeof getApiV1SmdaFieldsByFieldUuidWellboresAllQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1SmdaFieldsByFieldUuidWellboresAll({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1SmdaFieldsByFieldUuidWellboresAllQueryKey(options)
});

export const getApiV1SmdaFieldsByFieldUuidStratColumnsQueryKey = (options: Options<GetApiV1SmdaFieldsByFieldUuidStratColumnsData>) => createQueryKey('getApiV1SmdaFieldsByFieldUuidStratColumns', options);

/**
 * Get stratigraphic columns for a field
 */
export const getApiV1SmdaFieldsByFieldUuidStratColumnsOptions = (options: Options<GetApiV1SmdaFieldsByFieldUuidStratColumnsData>) => queryOptions<GetApiV1SmdaFieldsByFieldUuidStratColumnsResponse, DefaultError, GetApiV1SmdaFieldsByFieldUuidStratColumnsResponse, ReturnType<typeof getApiV1SmdaFieldsByFieldUuidStratColumnsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1SmdaFieldsByFieldUuidStratColumns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1SmdaFieldsByFieldUuidStratColumnsQueryKey(options)
});

export const getApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllQueryKey = (options: Options<GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllData>) => createQueryKey('getApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAll', options);

/**
 * Get all stratigraphic units by strat column identifier
 */
export const getApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllOptions = (options: Options<GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllData>) => queryOptions<GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllResponse, DefaultError, GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllResponse, ReturnType<typeof getApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAll({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllQueryKey(options)
});

export const getApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickQueryKey = (options: Options<GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickData>) => createQueryKey('getApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPick', options);

/**
 * Get wellbore picks for a drilled wellbore
 *
 * Allowed DetailType values are ZoneTop or ZoneBase. Default value is ZoneTop. DetailType is not applicable for Total Depth and will be ignored.
 */
export const getApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickOptions = (options: Options<GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickData>) => queryOptions<GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickResponse, GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickError, GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickResponse, ReturnType<typeof getApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPick({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickQueryKey(options)
});

/**
 * Update old zone relations for prognosis details
 */
export const postApiV1SmdaUpdateRelationMutation = (options?: Partial<Options<PostApiV1SmdaUpdateRelationData>>): UseMutationOptions<unknown, PostApiV1SmdaUpdateRelationError, Options<PostApiV1SmdaUpdateRelationData>> => {
    const mutationOptions: UseMutationOptions<unknown, PostApiV1SmdaUpdateRelationError, Options<PostApiV1SmdaUpdateRelationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1SmdaUpdateRelation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1SsdlWellboresByWellboreUuidPerforationsQueryKey = (options: Options<GetApiV1SsdlWellboresByWellboreUuidPerforationsData>) => createQueryKey('getApiV1SsdlWellboresByWellboreUuidPerforations', options);

/**
 * Get perforations for a wellbore
 */
export const getApiV1SsdlWellboresByWellboreUuidPerforationsOptions = (options: Options<GetApiV1SsdlWellboresByWellboreUuidPerforationsData>) => queryOptions<GetApiV1SsdlWellboresByWellboreUuidPerforationsResponse, DefaultError, GetApiV1SsdlWellboresByWellboreUuidPerforationsResponse, ReturnType<typeof getApiV1SsdlWellboresByWellboreUuidPerforationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1SsdlWellboresByWellboreUuidPerforations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1SsdlWellboresByWellboreUuidPerforationsQueryKey(options)
});

export const getTokenQueryKey = (options: Options<GetTokenData>) => createQueryKey('getToken', options);

/**
 * Gets a token for the application with the provided clientId
 */
export const getTokenOptions = (options: Options<GetTokenData>) => queryOptions<GetTokenResponse, DefaultError, GetTokenResponse, ReturnType<typeof getTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTokenQueryKey(options)
});

export const getSamPortalTokenQueryKey = (options?: Options<GetSamPortalTokenData>) => createQueryKey('getSamPortalToken', options);

/**
 * Gets a Token for SAM Portal for the Current Radix Environment (development/staging/production)
 */
export const getSamPortalTokenOptions = (options?: Options<GetSamPortalTokenData>) => queryOptions<GetSamPortalTokenResponse, DefaultError, GetSamPortalTokenResponse, ReturnType<typeof getSamPortalTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSamPortalToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSamPortalTokenQueryKey(options)
});

export const getSamPortalProductionTokenQueryKey = (options?: Options<GetSamPortalProductionTokenData>) => createQueryKey('getSamPortalProductionToken', options);

/**
 * Gets a token for SAM Portal in Production
 */
export const getSamPortalProductionTokenOptions = (options?: Options<GetSamPortalProductionTokenData>) => queryOptions<GetSamPortalProductionTokenResponse, DefaultError, GetSamPortalProductionTokenResponse, ReturnType<typeof getSamPortalProductionTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSamPortalProductionToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSamPortalProductionTokenQueryKey(options)
});

export const getApiV1UserUserAccessQueryKey = (options?: Options<GetApiV1UserUserAccessData>) => createQueryKey('getApiV1UserUserAccess', options);

/**
 * Get user access
 */
export const getApiV1UserUserAccessOptions = (options?: Options<GetApiV1UserUserAccessData>) => queryOptions<GetApiV1UserUserAccessResponse, DefaultError, GetApiV1UserUserAccessResponse, ReturnType<typeof getApiV1UserUserAccessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1UserUserAccess({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1UserUserAccessQueryKey(options)
});

export const getApiV1UserAccessCheckCollectionByFieldUuidQueryKey = (options: Options<GetApiV1UserAccessCheckCollectionByFieldUuidData>) => createQueryKey('getApiV1UserAccessCheckCollectionByFieldUuid', options);

/**
 * Checks what accesses current user has, PDM, SMDA, SSDL, OSDU, DataOffice, Pozo
 */
export const getApiV1UserAccessCheckCollectionByFieldUuidOptions = (options: Options<GetApiV1UserAccessCheckCollectionByFieldUuidData>) => queryOptions<GetApiV1UserAccessCheckCollectionByFieldUuidResponse, DefaultError, GetApiV1UserAccessCheckCollectionByFieldUuidResponse, ReturnType<typeof getApiV1UserAccessCheckCollectionByFieldUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1UserAccessCheckCollectionByFieldUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1UserAccessCheckCollectionByFieldUuidQueryKey(options)
});

export const getApiV1UserFutureAccessesQueryKey = (options: Options<GetApiV1UserFutureAccessesData>) => createQueryKey('getApiV1UserFutureAccesses', options);

/**
 * Get accesses that the user does not have and will need in the future
 */
export const getApiV1UserFutureAccessesOptions = (options: Options<GetApiV1UserFutureAccessesData>) => queryOptions<GetApiV1UserFutureAccessesResponse, DefaultError, GetApiV1UserFutureAccessesResponse, ReturnType<typeof getApiV1UserFutureAccessesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1UserFutureAccesses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1UserFutureAccessesQueryKey(options)
});

export const getApiV1UserApproversByFieldIdentifierQueryKey = (options: Options<GetApiV1UserApproversByFieldIdentifierData>) => createQueryKey('getApiV1UserApproversByFieldIdentifier', options);

/**
 * Get main approvers by field with filtering out the current user
 */
export const getApiV1UserApproversByFieldIdentifierOptions = (options: Options<GetApiV1UserApproversByFieldIdentifierData>) => queryOptions<GetApiV1UserApproversByFieldIdentifierResponse, DefaultError, GetApiV1UserApproversByFieldIdentifierResponse, ReturnType<typeof getApiV1UserApproversByFieldIdentifierQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1UserApproversByFieldIdentifier({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1UserApproversByFieldIdentifierQueryKey(options)
});

export const getApiV1UserApproversByFieldIdentifierAllQueryKey = (options: Options<GetApiV1UserApproversByFieldIdentifierAllData>) => createQueryKey('getApiV1UserApproversByFieldIdentifierAll', options);

/**
 * Get main approvers by field without filtering out the current user
 */
export const getApiV1UserApproversByFieldIdentifierAllOptions = (options: Options<GetApiV1UserApproversByFieldIdentifierAllData>) => queryOptions<GetApiV1UserApproversByFieldIdentifierAllResponse, DefaultError, GetApiV1UserApproversByFieldIdentifierAllResponse, ReturnType<typeof getApiV1UserApproversByFieldIdentifierAllQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1UserApproversByFieldIdentifierAll({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1UserApproversByFieldIdentifierAllQueryKey(options)
});

export const getApiV1UserSubmittersByFieldIdentifierQueryKey = (options: Options<GetApiV1UserSubmittersByFieldIdentifierData>) => createQueryKey('getApiV1UserSubmittersByFieldIdentifier', options);

/**
 * Get submitters by field with filtering out the current user
 */
export const getApiV1UserSubmittersByFieldIdentifierOptions = (options: Options<GetApiV1UserSubmittersByFieldIdentifierData>) => queryOptions<GetApiV1UserSubmittersByFieldIdentifierResponse, DefaultError, GetApiV1UserSubmittersByFieldIdentifierResponse, ReturnType<typeof getApiV1UserSubmittersByFieldIdentifierQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1UserSubmittersByFieldIdentifier({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1UserSubmittersByFieldIdentifierQueryKey(options)
});

export const getApiV1UserSubmittersByFieldIdentifierAllQueryKey = (options: Options<GetApiV1UserSubmittersByFieldIdentifierAllData>) => createQueryKey('getApiV1UserSubmittersByFieldIdentifierAll', options);

/**
 * Get submitters by field without filtering out the current user
 */
export const getApiV1UserSubmittersByFieldIdentifierAllOptions = (options: Options<GetApiV1UserSubmittersByFieldIdentifierAllData>) => queryOptions<GetApiV1UserSubmittersByFieldIdentifierAllResponse, DefaultError, GetApiV1UserSubmittersByFieldIdentifierAllResponse, ReturnType<typeof getApiV1UserSubmittersByFieldIdentifierAllQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1UserSubmittersByFieldIdentifierAll({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1UserSubmittersByFieldIdentifierAllQueryKey(options)
});

export const getApiV1UserApproversByFieldIdentifierBackupQueryKey = (options: Options<GetApiV1UserApproversByFieldIdentifierBackupData>) => createQueryKey('getApiV1UserApproversByFieldIdentifierBackup', options);

/**
 * Get backup approvers by field with filtering out the current user
 */
export const getApiV1UserApproversByFieldIdentifierBackupOptions = (options: Options<GetApiV1UserApproversByFieldIdentifierBackupData>) => queryOptions<GetApiV1UserApproversByFieldIdentifierBackupResponse, DefaultError, GetApiV1UserApproversByFieldIdentifierBackupResponse, ReturnType<typeof getApiV1UserApproversByFieldIdentifierBackupQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1UserApproversByFieldIdentifierBackup({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1UserApproversByFieldIdentifierBackupQueryKey(options)
});

export const getApiV1UserApproversByFieldIdentifierBackupAllQueryKey = (options: Options<GetApiV1UserApproversByFieldIdentifierBackupAllData>) => createQueryKey('getApiV1UserApproversByFieldIdentifierBackupAll', options);

/**
 * Get backup approvers by field without filtering out the current user
 */
export const getApiV1UserApproversByFieldIdentifierBackupAllOptions = (options: Options<GetApiV1UserApproversByFieldIdentifierBackupAllData>) => queryOptions<GetApiV1UserApproversByFieldIdentifierBackupAllResponse, DefaultError, GetApiV1UserApproversByFieldIdentifierBackupAllResponse, ReturnType<typeof getApiV1UserApproversByFieldIdentifierBackupAllQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1UserApproversByFieldIdentifierBackupAll({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1UserApproversByFieldIdentifierBackupAllQueryKey(options)
});

export const getApiV1UserQueryKey = (options: Options<GetApiV1UserData>) => createQueryKey('getApiV1User', options);

/**
 * Search for users by name or email - top 25
 */
export const getApiV1UserOptions = (options: Options<GetApiV1UserData>) => queryOptions<GetApiV1UserResponse, DefaultError, GetApiV1UserResponse, ReturnType<typeof getApiV1UserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1User({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1UserQueryKey(options)
});

export const getApiV1UserShortnamesQueryKey = (options?: Options<GetApiV1UserShortnamesData>) => createQueryKey('getApiV1UserShortnames', options);

/**
 * Get users by shortnames
 */
export const getApiV1UserShortnamesOptions = (options?: Options<GetApiV1UserShortnamesData>) => queryOptions<GetApiV1UserShortnamesResponse, DefaultError, GetApiV1UserShortnamesResponse, ReturnType<typeof getApiV1UserShortnamesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1UserShortnames({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1UserShortnamesQueryKey(options)
});

export const getApiV1UserPhotoByShortnameQueryKey = (options: Options<GetApiV1UserPhotoByShortnameData>) => createQueryKey('getApiV1UserPhotoByShortname', options);

/**
 * Get user's photo
 */
export const getApiV1UserPhotoByShortnameOptions = (options: Options<GetApiV1UserPhotoByShortnameData>) => queryOptions<GetApiV1UserPhotoByShortnameResponse, DefaultError, GetApiV1UserPhotoByShortnameResponse, ReturnType<typeof getApiV1UserPhotoByShortnameQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1UserPhotoByShortname({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1UserPhotoByShortnameQueryKey(options)
});

export const getApiV1UserDefaultViewQueryKey = (options?: Options<GetApiV1UserDefaultViewData>) => createQueryKey('getApiV1UserDefaultView', options);

/**
 * Get user default view
 */
export const getApiV1UserDefaultViewOptions = (options?: Options<GetApiV1UserDefaultViewData>) => queryOptions<GetApiV1UserDefaultViewResponse, DefaultError, GetApiV1UserDefaultViewResponse, ReturnType<typeof getApiV1UserDefaultViewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1UserDefaultView({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1UserDefaultViewQueryKey(options)
});

/**
 * Update user default view
 */
export const putApiV1UserDefaultViewMutation = (options?: Partial<Options<PutApiV1UserDefaultViewData>>): UseMutationOptions<PutApiV1UserDefaultViewResponse, PutApiV1UserDefaultViewError, Options<PutApiV1UserDefaultViewData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1UserDefaultViewResponse, PutApiV1UserDefaultViewError, Options<PutApiV1UserDefaultViewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1UserDefaultView({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update user favorite fields
 */
export const putApiV1UserFavoriteFieldsByFieldUuidMutation = (options?: Partial<Options<PutApiV1UserFavoriteFieldsByFieldUuidData>>): UseMutationOptions<PutApiV1UserFavoriteFieldsByFieldUuidResponse, PutApiV1UserFavoriteFieldsByFieldUuidError, Options<PutApiV1UserFavoriteFieldsByFieldUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1UserFavoriteFieldsByFieldUuidResponse, PutApiV1UserFavoriteFieldsByFieldUuidError, Options<PutApiV1UserFavoriteFieldsByFieldUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1UserFavoriteFieldsByFieldUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDrilledWellsFeaturesByFieldQueryKey = (options: Options<GetDrilledWellsFeaturesByFieldData>) => createQueryKey('getDrilledWellsFeaturesByField', options);

/**
 * Get drilled wells for a field
 */
export const getDrilledWellsFeaturesByFieldOptions = (options: Options<GetDrilledWellsFeaturesByFieldData>) => queryOptions<GetDrilledWellsFeaturesByFieldResponse, DefaultError, GetDrilledWellsFeaturesByFieldResponse, ReturnType<typeof getDrilledWellsFeaturesByFieldQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDrilledWellsFeaturesByField({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDrilledWellsFeaturesByFieldQueryKey(options)
});
